/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _components = require('components');

var ArticleRollItem = (function (_Component) {
	_inherits(ArticleRollItem, _Component);

	function ArticleRollItem() {
		_classCallCheck(this, ArticleRollItem);

		_Component.apply(this, arguments);
	}

	ArticleRollItem.prototype.render = function render() {
		var _classNames, _classNames2;

		var styles = require('./ArticleRollItem.css');

		var _props = this.props;
		var categories = _props.categories;
		var specialSeries = _props.specialSeries;

		var contentStyles = _classnames2['default']((_classNames = {}, _classNames[styles.Content] = this.props.imageSrc, _classNames[styles['Content--wide']] = !this.props.imageSrc, _classNames));

		var titleClasses = _classnames2['default']((_classNames2 = {}, _classNames2[styles.Title] = true, _classNames2[styles['Title--small']] = this.props.smallTitle, _classNames2));

		return _react2['default'].createElement(
			'article',
			{ className: styles.Base },
			this.props.imageSrc ? _react2['default'].createElement(
				'figure',
				{ className: styles.Figure },
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.Title, to: this.props.uri },
					_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + this.props.imageSrc })
				)
			) : null,
			_react2['default'].createElement(
				'div',
				{ className: contentStyles },
				_react2['default'].createElement(_components.MetaBar, {
					categories: categories,
					postDate: this.props.postDate,
					specialSeries: specialSeries }),
				_react2['default'].createElement(
					'header',
					{ className: styles.Header },
					_react2['default'].createElement(
						'h1',
						null,
						_react2['default'].createElement(_reactRouter.Link, { className: titleClasses, to: this.props.uri, dangerouslySetInnerHTML: { __html: this.props.title } })
					)
				)
			)
		);
	};

	_createClass(ArticleRollItem, null, [{
		key: 'propTypes',
		value: {
			categories: _react.PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]),
			imageSrc: _react.PropTypes.string,
			postDate: _react.PropTypes.string.isRequired,
			smallTitle: _react.PropTypes.bool,
			specialSeries: _react.PropTypes.object,
			title: _react.PropTypes.string.isRequired,
			uri: _react.PropTypes.string.isRequired
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			postDate: 'May 11, 1973',
			smallTitle: false,
			title: 'The Title',
			uri: '/'
		},
		enumerable: true
	}]);

	return ArticleRollItem;
})(_react.Component);

exports['default'] = ArticleRollItem;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ArticleRollItem/ArticleRollItem.js
 ** module id = 673
 ** module chunks = 0
 **/